import React, { useContext, useEffect, useState } from "react";
import { AdditionalServicesList, ContentContainer, Actions } from "../../../../../styles/orderform.tsx";
import { OrderContext } from "../../OrderContext.tsx";
import { useAppTranslation } from "../../../../../translations/useAppTranslation.ts";

interface PhaseThreeProps {
  emptyValueByDefault?: boolean;
}

function PhaseThree(props: PhaseThreeProps) {
  const { emptyValueByDefault } = props;
  const { t, db_t } = useAppTranslation();
  const { formValues, handleFormChange, addOns, toPhase } = useContext(OrderContext);
  const [radioAddons, setRadioAddons] = useState(addOns.filter(addon => addon.group?.label === 'Sähkön alkuperä'));
  const [checkboxAddons] = useState(addOns.filter(addon => addon.group?.label !== 'Sähkön alkuperä'));

  // give checkbox change event type
  const toggleAdditionalService = (e: React.FormEvent<HTMLInputElement>) => {
    const { value } = e.target as HTMLInputElement;
    const currentServices = formValues['additional-services'].split(',').filter((service: string) => service !== '');
    const newServices = currentServices.includes(value) ? currentServices.filter((service: string) => service !== value) : [...currentServices, value];
    const customTarget = {
      target: {
        name: 'additional-services',
        value: newServices.join(','),
      },
    } as React.ChangeEvent<HTMLInputElement>;
    handleFormChange(customTarget);
  }

  const next = (emptyValueByDefault === true ? formValues['additional-services'] === 'seka' : false) ? () => { } : () => toPhase(4);

  useEffect(() => {
    if (emptyValueByDefault === true) {
      // get addon with hs_id 0 and put to last position. Other shoulb be sorted as they are in addOns
      const sekaAddon = radioAddons.find(addon => addon.hs_id === 0);
      const sorted = radioAddons.filter(addon => addon.hs_id !== 0);
      // add seka addon to the end of the array
      if (sekaAddon) {
        sorted.push(sekaAddon);
      }
      setRadioAddons(sorted);

      if (formValues['additional-services'] === '') {
        // If emptyValueByDefault is true, set the initial value of 'additional-services' to 'seka'
        // This is to ensure that the user has to select a service. Next button is disabled until a service is selected(other than seka is selected).
        handleFormChange({
          target: {
            name: 'additional-services',
            value: 'seka',
          },
        } as React.ChangeEvent<HTMLInputElement>);
      }

    }
  }, [emptyValueByDefault]);

  return (
    <>
      <ContentContainer>
        {radioAddons.length > 0 && (
          <>
            <h3>{t('phaseThree.electricityOrigin')}</h3>
            <AdditionalServicesList id="additional-services-radio">
              {radioAddons.map(addOn => (
                <label
                  htmlFor={addOn.hs_id?.toString()}
                  className={'additional-service ' + ((addOn.class && !emptyValueByDefault) ? addOn.class : '')}
                  key={addOn.addon_product_template_no}>
                  <div className="header">
                    <input
                      type="radio"
                      id={addOn.hs_id?.toString()}
                      name="additional-services"
                      value={addOn.addon_product_template_no}
                      checked={addOn.addon_product_template_no === formValues['additional-services']}
                      onChange={handleFormChange} />
                    <div className="title">{t('addonTypes.' + addOn.type.label)}</div>
                  </div>
                  <div className="description" dangerouslySetInnerHTML={{ __html: db_t(addOn, 'description').replaceAll('\\n', '') }}></div>
                  <div className="bottom">
                    {addOn.monthly_price > 0 ? <div className="price">+{addOn.monthly_price} {t('common.€/month')}</div> : <span>{t('phaseThree.noSurcharge')}</span>}
                    {addOn.label && <div className="label image">{db_t(addOn, 'label')}</div>}
                    {addOn.icon && !addOn.label && <img className="image" src={addOn.icon.url} alt={addOn.icon.altText} height={40} width={40} />}
                  </div>
                </label>
              ))}
            </AdditionalServicesList>
          </>)}
        {checkboxAddons.length > 0 && (
          <>
            <h3>{t('phaseThree.otherServices')}</h3>
            <AdditionalServicesList id="additional-services-checkbox">
              {checkboxAddons.map(addOn => (
                <label
                  htmlFor={addOn.hs_id.toString()}
                  className={'additional-service ' + ((addOn.class && !emptyValueByDefault) ? addOn.class : '')}
                  key={addOn.addon_product_template_no}>
                  <div className="header">
                    <input
                      type="checkbox"
                      id={addOn.hs_id.toString()}
                      name="additional-services"
                      value={addOn.addon_product_template_no}
                      checked={formValues['additional-services'].includes(addOn.addon_product_template_no)}
                      onChange={toggleAdditionalService} />
                    <div className="title">{t('addonTypes.' + addOn.type.label)}</div>
                  </div>
                  <div className="description" dangerouslySetInnerHTML={{ __html: db_t(addOn, 'description') }}></div>
                  <div className="bottom">
                    {addOn.monthly_price > 0 ? <div className="price">+ {addOn.monthly_price} {t('common.€/month')}</div> : <span>{t('phaseThree.noSurcharge')}</span>}
                    {addOn.label && <div className="label image">{db_t(addOn, 'label')}</div>}
                    {addOn.icon && !addOn.label && <img className="image" src={addOn.icon.url} alt={addOn.icon.altText} height={40} width={40} />}
                  </div>
                </label>
              ))}
            </AdditionalServicesList>
          </>
        )}
      </ContentContainer>

      <Actions id="next">
        <button
          type="button"
          className={"primary purple" + ((emptyValueByDefault === true ? formValues['additional-services'] === 'seka' : false) ? ' disabled' : '')}
          onClick={next}>
          {t('common.next')}
        </button>
      </Actions>
    </>
  );
}

export default PhaseThree;
